import React from "react";
import DisplayArrow from "../DisplayArrow/DisplayArrow";

type SuscriptionComponentProps = {
  text: string;
  outdatedPlan: boolean;
  isDisabled: boolean;
  isExpanded: boolean;
  setIsExpanded: (value: boolean) => void
}

const RectangleComponent: React.FC<SuscriptionComponentProps> = ({
  text,
  outdatedPlan,
  isDisabled,
  isExpanded,
  setIsExpanded,
}) => {

  return (
      <div 
        className={
          `rectangleComponent 
          ${isExpanded ? 'rectangleComponentSmall' : '' }
          ${isDisabled ? 'disabled' : '' }
          ${outdatedPlan ? 'outDatedRectangleComponent' : '' }` }
        onClick={() => setIsExpanded(!isExpanded)}>
          <div className="textRectangleComponent">
            <DisplayArrow expanded={isExpanded} />
            {text}
          </div>
      </div>
  );
};

export default RectangleComponent;